<template>
  <div class="activity-log-item">
    <el-form :model="form">
      <div class="activity-log-item__content-wrap">
        <div class="activity-log-item__status">
          <span><i :class="itemIcon"></i></span>
        </div>
        <div class="activity-log-item__content">
          <div class="activity-log-ite__time">{{title}}</div>
          <div class="activity-log-ite__desc">{{form.description}}</div>
          <!-- SLOT -->
          <slot />
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ActivityInfoLogItem',
  props: {
    data: { type: Object, required: true },
    formModel: { type: Function, required: true }
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        this.form = this.copyObjectProps(this.formModel(), value)
      }
    }
  },
  data () {
    return {
      form: {}
    }
  },
  computed: {
    title () {
      return [this.data.entryDate, this.data.employeeName].filter(Boolean).join(' | ')
    },
    itemIcon () {
      return this.data.isEmployeeEntry
        ? 'icon-db tools-operation'
        : 'icon-db tools-refresh'
    }
  }
}
</script>
<style lang="stylus">
  .activity-log-item__content-wrap{
    display flex
  }
  .activity-log-item__content{
    width 100%
    display flex
    align-content flex-start
    flex-direction column
  }
  .activity-log-item__status{
    color grey
    padding 0 1rem
  }
  .activity-log-ite__time{
    font 100% 'Roboto', Arial, Tahoma, Geneva, sans-serif
    line-height 30px
    font-size 1.4rem
    font-weight 400
    color #65646c
  }
  .activity-log-ite__desc{
    font 100% 'Roboto', Arial, Tahoma, Geneva, sans-serif
    font-size 1.3rem
    font-weight 400
    color #65646c
    padding-bottom 1rem
    border-bottom 1px solid #bcbbbe
  }
</style>
